//dependencies
import { format } from "date-fns";
import React from "react";

//components
import { Avatar } from "@performyard/py-components";

import AvatarGroup from "../../../components/AvatarGroup";
import Link from "../../../components/Link";
import Typography from "../../../components/Text";
import TruncatedText from "../../../components/Text/TruncatedText";

//utils
import toEmployeeUrl from "../../../utils/URLs/Employee";
import { Feedback } from "../../UserFeedback/utils";

//css
import css from "../CompanyFeedback.module.scss";

const SharedWithTextMap = {
	subject: "Subject",
	manager: "Manager",
	all: "Everyone",
	everyone: "Everyone",
	me: "Me",
	"subject-+-manager": "Subject & Subject's Manager",
	"subject-manager": "Subject's Manager",
};

export const getCompanyFeedbackColumns = () => {
	return [
		{
			id: "subject.name",
			label: "Subject",
			width: "11%",
			isSortable: true,
			mobileViewHideColumn: 650,
			getter: (r: Feedback) => {
				const subjects = r?.subject || [];
				const renderedList =
					subjects.length < 2 ? (
						subjects.map((subject) => (
							<div key={`employee-subject-${subject?._id}`} className={css.userBox}>
								<Avatar
									size={20}
									dangerouslySetClassName={css.userAvatar}
									id={subject?._id}
									alt={`${subject?.name}'s avatar`}
								/>
								<div className={css.userName}>
									<Link href={toEmployeeUrl(subject?._id)} forceHardReload={true}>
										{subject?.name}
									</Link>
								</div>
							</div>
						))
					) : (
						<AvatarGroup canShowModal employees={subjects} maxLength={5} />
					);

				return <div className={css.avatarList}>{renderedList}</div>;
			},
		},
		{
			id: "author.name",
			label: "Author",
			width: "11%",
			isSortable: true,
			getter: (r: Feedback) => {
				const authors = r?.author || [];

				const renderedList =
					authors.length < 2 ? (
						authors.map((subject) => (
							<div key={`employee-subject-${subject?._id}`} className={css.userBox}>
								<Avatar
									size={20}
									dangerouslySetClassName={css.userAvatar}
									id={subject?._id}
									alt={`${subject?.name}'s avatar`}
								/>
								<div className={css.userName}>
									<Link href={toEmployeeUrl(subject?._id)} forceHardReload={true}>
										{subject?.name}
									</Link>
								</div>
							</div>
						))
					) : (
						<AvatarGroup canShowModal employees={authors} maxLength={5} />
					);

				return <div className={css.avatarList}>{renderedList}</div>;
			},
		},
		{
			id: "shared_with",
			label: "Shared With",
			width: "11%",
			isSortable: true,
			getter: (r: Feedback) => (
				<TruncatedText
					text={SharedWithTextMap[r.shared_with]}
					maxWidth={100}
					weight="regular"
					size="paragraph-3"
				/>
			),
		},
		{
			id: "last_updated",
			label: "Date",
			width: "8%",
			isSortable: true,
			getter: (r: Feedback) => {
				const lastUpdated = new Date(r.last_updated);
				return (
					<Typography weight="regular" size="paragraph-3">
						{format(lastUpdated, "MMM d, yyyy")}
					</Typography>
				);
			},
		},
		{
			id: "content",
			label: "Content",
			width: "37%",
			isSortable: false,
			getter: (r: Feedback) => {
				return (
					<Link href={`/view-feedback/${r._id}`} forceHardReload={true}>
						<TruncatedText
							useTooltip="never"
							text={r.content || ""}
							maxWidth={360}
							maxLines={3}
							weight="regular"
							size="paragraph-3"
						/>
					</Link>
				);
			},
		},
		{
			id: "categories",
			label: "Hashtags",
			width: "9%",
			isSortable: true,
			getter: (r: Feedback) => (
				<TruncatedText text={r.categories?.join(" ") || ""} maxWidth={100} weight="regular" size="caption" />
			),
		},
		{
			id: "response_to_request",
			label: "Requested",
			width: "9%",
			isSortable: true,
			getter: (r: Feedback) => {
				return (
					<Typography weight="regular" size="paragraph-3">
						{r.response_to_request ? "Yes" : "No"}
					</Typography>
				);
			},
		},
	];
};
